import CaseStudyTemplate from "@/components/case-studies/case-study-template";
import { caseStudyPages, getCaseStudyPage } from "@/constants/case-study-pages";

export default function CaseStudyPage({ caseStudy }) {
  return <CaseStudyTemplate caseStudy={caseStudy} />;
}

CaseStudyPage.serviceTheme = "blue";

export function getStaticPaths() {
  return {
    paths: caseStudyPages.map((caseStudy) => ({
      params: { slug: caseStudy.slug },
    })),
    fallback: false,
  };
}

export function getStaticProps({ params }) {
  const caseStudy = getCaseStudyPage(params.slug);

  if (!caseStudy) {
    return { notFound: true };
  }

  return {
    props: { caseStudy },
  };
}
